// Runtime configuration that's evaluated in the browser, not at build time
export function getApiBaseUrl(): string {
  // Check if we're running on Render or another production domain
  const hostname = window.location.hostname;
  
  // List of production hostnames
  const productionHosts = [
    'xora-v2-frontend.onrender.com',
    'app.xora.de', // Future custom domain
    'xora.pflegehilfe-senioren.de' // Future custom domain
  ];
  
  // Check if current hostname is a production host
  const isProductionHost = productionHosts.some(host => hostname.includes(host));
  
  // Force production URL for any non-localhost hostname
  if (isProductionHost || (hostname !== 'localhost' && hostname !== '127.0.0.1')) {
    return 'https://xora-v2-backend.onrender.com';
  }
  
  // Development/local environment
  return import.meta.env.VITE_API_URL || 
         import.meta.env.VITE_BACKEND_URL || 
         'http://localhost:8001';
}

// Debug logging (always active to help troubleshooting)
console.log('[XORA] API Configuration:', {
  hostname: window.location.hostname,
  apiUrl: getApiBaseUrl(),
  env: {
    VITE_API_URL: import.meta.env.VITE_API_URL,
    VITE_BACKEND_URL: import.meta.env.VITE_BACKEND_URL
  }
});